import React, { Component } from "react";
import './TripwiseReport.css'
import InMultiSelect from "../InMultiSelect/InMultiSelect";
import DatePicker from "react-datepicker";
import moment from "moment";
import ReportAPIs from "../../../../APIs/ReportAPIs";
import TripTimeline from "./TripTimeline";
import { JSONToCSVConvertor } from "../../../../helpers/helperFunctions";


class TripwiseReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            startDate: moment(Date.now()).startOf("day").subtract(1, "days").toDate(),
            endDate: moment(Date.now()).startOf("day").toDate(),
            tripTableData: [],
            busy:false,
            expanded:false,
            movedataBusy:false,
            tripData: {},
            errorMsg: null,
            igonHead: [
                {key:"vehicleno", name: "Vehicle No"},
                {key:"status", name:"Status"},
                {key:"distance", name:"Distance"},
                {key:"movingduration", name:"Moving Duration"},
                {key:"total_duration", name:"Total Duration"},
                {key:"idleduration", name:"Idle Duration"},
                
            ],
            ignoffHead:[
                {key:"vehicleno", name: "Vehicle No"},
                {key:"status", name:"Status"},
                {key:"total_duration", name:"Total Duration"},
                {key:"startedat", name :"Started At"},
                {key:"endedat", name :"Ended At"},
                {key:"startlat", name:"Latitude"},
                {key:"startlng", name:"Longitude"},
                {key:"drained", name:"Battery Drained"},
            ],
        }
        this.contentRef = null;
    }
    
    setContentRef = (element) => {
        this.contentRef = element; // Assign the ref dynamically
      };
    
    changeVehicle = function (v) {
        window.saveVehicleState(v);
        this.vehicleSelect.setFocusActive();
    };
    handleStartDate = (date) => {
        this.setState({ startDate: date });
      };
      handleEndDate = (date) => {
        this.setState({ endDate: date });
      };

    getReport = () => {
        this.setState({busy:true, tripTableData:[], errorMsg:null})
        let vehicles = []
        let starttime = moment(this.state.startDate).unix()*1000
        let endtime = moment(this.state.endDate).unix()*1000
        
        if(endtime <= starttime) {
            this.setState({busy:false, errorMsg: "Start time should be less than end time"})
            return
        }
        if(endtime - starttime > 1000 * 60 * 60 * 24 * 15){
            this.setState({busy:false, errorMsg: "You can not select more than 15 days"})
            return

        }
        window.selectedVehicles.map((veh) => {
            vehicles.push(veh.data.id)
        })

        let body = {
            vehicleid: vehicles,
            starttime: starttime,
            endtime: endtime,
          
        }
        ReportAPIs.getTripwiseMovement(body).then((resp) => {
            this.setState({busy:false})

            Object.values(resp).map((data,index) =>{
                this.setState({tripTableData: data})
            })
        }).catch((e) => {
            this.setState({busy:false})
        })
    }  

    handleDownload =()=>{
        const { tripTableData } = this.state;
    const csvData = tripTableData.map(trip => {
        return {
            VehicleNo: trip.vehicleno,
            Status: trip.status,
            Distance: trip.total_can_distance ? trip.total_can_distance.toFixed(2) + " Km" : "NA",
            MovingDuration: this.convertMilliseconds(trip.movingduration),
            TotalDuration: this.convertMilliseconds(trip.total_duration),
            IdleDuration: this.convertMilliseconds(trip.idleduration),
            StartedAt: moment(trip.startedat).format("DD-MMM-YY hh:mm A"),
            EndedAt: moment(trip.endedat).format("DD-MMM-YY hh:mm A"),
            StartLocation: trip.startlat && trip.startlng ? "(" + trip.startlat + ", " + trip.startlng + ")" : "NA",
            EndLocation: trip.endlat && trip.endlng ? "(" + trip.endlat + ", " + trip.endlng + ")" : "NA",
        };
    });
    JSONToCSVConvertor(csvData, "Tripwise_Report", true);
    }

     toggleExpand = (index, trip) => {
    
        this.setState((prevState) => {
            const isSameIndex = prevState.expanded === index;
    
            return {
                expanded: isSameIndex ? null : index, // Collapse if clicking the same, otherwise expand
                tripData: [], // Clear tripData when switching
                movedataBusy: true,
            };
        }, () => {
            if (this.contentRef) {
                if (this.state.expanded === index) {
                    this.contentRef.style.height = this.contentRef.scrollHeight + 90 + "px";
                } else {
                    // Shrink: Set height to scrollHeight first for smooth transition
                    this.contentRef.style.height = this.contentRef.scrollHeight + "px";
    
                    // Force reflow (trick to ensure transition works)
                    // this.contentRef.offsetHeight;
    
                    // Now set height to 0 for smooth collapse
                    this.contentRef.style.height = "0px";
                }
            }
    
            if (this.state.expanded !== null && trip.ignstatus) {  
                let body = { tripid: trip.tripid };
                ReportAPIs.getTripMovementData(body).then((resp) => {
                    this.setState({ tripData: resp });
                    setTimeout(() => {
                        this.setState({ movedataBusy: false });
                    }, 1000);
                }).catch((e) => {
                    this.setState({ movedataBusy: false });
                });
            } else {
                this.setState({ movedataBusy: false });
            }
        });
    };
    
    
    


    
    filterCanGps = (key) => {
        let keys = ["distance", "startodo", "endodo"]
        if(keys.includes(key)) return true
        else return false
    }

    isheaderValid = (trip,key) => {
        if(key === "drained"){
            if((trip.endsoc - trip.startsoc) >= 0) return false
        }
        return true
    }
    
    getValue = (trip,key) => {
        let value = null
            switch (key) {
                case "distance":
                    if(trip.iscanavailable){
                        value =  (trip.total_can_distance).toFixed(2)
                        value = value < 0.01 ? 0 : value + "Km"

                    }else{
                        value = value < 0.01 ? 0 : value +" Km"
                    } 
                    
                    break;
                    
                case "total_duration":
                    value = this.convertMilliseconds(trip.total_duration,key)  
                    break 
                case "endodo":
                    console.log("calling end odo can",value,trip)

                    if(trip.iscanavailable){
                        value =  (trip.endcanodo).toFixed(2)

                    }else value = (trip.endgpsodo).toFixed(2)
                    
                    break;    
            
                case "startodo":
                    if(trip.iscanavailable){
                        value =  (trip.startcanodo).toFixed(2)

                    }else value = (trip.startgpsodo).toFixed(2) 
                    
                    break;

                case "total_duration":
                    value = this.convertMilliseconds(trip.total_duration,key)  
                    break 

                case "movingduration":
                    value = this.convertMilliseconds(trip.movingduration,key)  
                    break 
                    
                case "idleduration":
                    value = this.convertMilliseconds(trip.idleduration,key)  
                    break 

                case "startedat":
                    value = moment(trip.startedat).format("DD-MMM-YY hh:mm A") 
                    break 

                case "endedat":
                    value = moment(trip.endedat).format("DD-MMM-YY hh:mm A") 
                    break 
                    case "drained":
                        value = trip.endsoc && trip.startsoc && (trip.endsoc - trip.startsoc) < 0 ? (trip.endsoc - trip.startsoc): ""
                        break 

                default:
                    value = trip[key] !== null ? trip[key] : "NA"
                    break;
            }
        return value
    }

    convertMilliseconds = (ms,key) => {
        let totalSeconds = Math.floor(ms / 1000);
        let hours = Math.floor(totalSeconds / 3600);
        let minutes = Math.floor((totalSeconds % 3600) / 60);
        let seconds = totalSeconds % 60;
    
        if (hours > 0) {
            return `${hours}h ${minutes}m ${seconds}s`;
        } else if (minutes > 0) {
            return `${minutes}m ${seconds}s`;
        } else {
            if(seconds > 0){
                return `${seconds}s`;

            }else return seconds
        }
    };
    
    openMap = (lat, lng) => {
        if (lat && lng) {
            const mapUrl = `https://www.google.com/maps?q=${lat},${lng}`;
            window.open(mapUrl, "_blank");
        }
    };
    
    generateTableRow = (trip, index) => {
        const isExpanded = this.state.expanded === index;
        let header = trip.ignstatus ? this.state.igonHead :this.state.ignoffHead
        const visibleHeaders = isExpanded  ? header : trip.ignstatus ? header.slice(0, 6) :  header.slice(0, 8) ;
        const rows = [];
        let limit = 8

        for (let i = 0; i < visibleHeaders.length; i += limit) {
            rows.push(visibleHeaders.slice(i, i + limit));
        }
    
        return (
            <div className="card" key={index}>
                <div className="card-table">
                    {rows.map((row, rowIndex) => (
                        <div className="table-row" key={rowIndex}>
                            {row.map((header, headerIndex) => (
                                <div className="table-cols-container" key={headerIndex}>
                                            <span className={trip.iscanavailable && this.filterCanGps(header.key) ? "can-data" : !trip.iscanavailable && this.filterCanGps(header.key) ? "gps-data" :""}>
                                                <span className="data-label">{trip.iscanavailable && this.filterCanGps(header.key) ? "CAN Data" : !trip.iscanavailable && this.filterCanGps(header.key) ? "GPS Data" :""}</span>
                                            </span>

                                    {this.isheaderValid(trip,header.key) ? <div className="table-cols" key={header.key}>
                                            <span className="col-head">{header.name}:</span>
                                        <span className="col-data">{
                                        this.getValue(trip,header.key)}</span>
                                    </div> :null}
                                </div>
                            ))}
                        </div>
                    ))}
                   {isExpanded && trip.ignstatus ?
                   
                    <div
                    className={`row2-container ${isExpanded ? "expanded" : ""}`}
                    ref={this.setContentRef}
                    style={{ height: "0px" }}
                  >

                       
                         <div className="latlng">
                            {/* Column for Start & End Labels */}
                            <div className="label-column">
                                <span className="se-start">Start</span>
                                <span className="se-end">End</span>
                            </div>

                            {/* Column for Latitude */}
                            <div className="lat-col">
                                <span className="lat-header">Latitude</span>
                                <span onClick={() => this.openMap(trip.startlat, trip.startlng)}>{trip.startlat}</span>
                                <span onClick={() => this.openMap(trip.endlat, trip.endlng)}>{trip.endlat}</span>
                            </div>

                            {/* Column for Longitude */}
                            <div className="lng-col">
                                <span className="lng-header">Longitude</span>
                                <span onClick={() => this.openMap(trip.startlat, trip.startlng)}>{trip.startlng}</span>
                                <span onClick={() => this.openMap(trip.endlat, trip.endlng)}>{trip.endlng}</span>
                            </div>
                            </div>

                        {trip.ignstatus ? <div className="soc-container">
                            <div className="soc-header">SoC</div>
                            <div className="soc-values">
                                <div className="soc-start">
                                    <span className="start">Start</span>
                                    <span>{trip.startsoc !== null ? trip.startsoc+"%" : "NA"}</span>
                                </div>
                                <div className="soc-end">
                                    <span className="end">End</span>
                                    <span>{trip.endsoc !== null ? trip.endsoc+"%" : "NA"}</span>
                                </div>
                            </div>
                            

                        </div> :null}
                        {trip.ignstatus ? <div className="odo-container">
                            <div className="odo-header-container">
                                <span className={trip.iscanavailable ? "odo-can-data" : "odo-gps-data"}>
                                        <span className="data-label">{trip.iscanavailable ? "CAN Data" : "GPS Data"}</span>
                                </span>
                                <div className="odo-header">
                                    
                                    <span>Odometer</span>
                                </div>
                            </div>
                            <div className="odo-values">
                                <div className="odo-start">
                                    <span className="start">Start</span>
                                    <span>
                                        {trip.iscanavailable ? trip.startcanodo !== null ? (trip.startcanodo).toFixed(2) + " Km" : "NA" : trip.startgpsodo !== null ? (trip.startgpsodo).toFixed(2) + " Km" : "NA"}</span>
                                </div>
                                <div className="odo-end">
                                    <span className="end">End</span>
                                    <span>{trip.iscanavailable ? trip.endcanodo !== null ? (trip.endcanodo).toFixed(2) + " Km" : "NA" : trip.endgpsodo !== null ? (trip.endgpsodo).toFixed(2) + " Km" : 'NA'}</span>
                                </div>
                            </div>
                            
                        </div> : null}
                        {trip.ignstatus ? <div className="trip-container">
                        <div className="trip-header">Trip</div>
                            <div className="trip-values">
                                <div className="trip-start">
                                    <span className="start">Start</span>
                                    <span>{moment(trip.startedat).format("DD-MMM-YY HH:mm A")}</span>
                                </div>
                                <div className="trip-end">
                                    <span className="end">End</span>
                                    <span>{moment(trip.endedat).format("DD-MMM-YY HH:mm A")}</span>
                                </div>
                            </div>

                        </div> :null}
                    </div> :null}
                </div>
                {isExpanded && trip.ignstatus  ? (
                    <div className="card-table-2"> 
                        {/* <div className="table-row-2">other params</div> */}
                        <div className={`move-idle-bar ${isExpanded ? "show" : ""}`}>
                           {this.state.movedataBusy ? <div className="loader"> </div>: this.state.tripData && this.state.tripData.movement_data && this.state.tripData.movement_data.length ?
                            <TripTimeline tripData={this.state.tripData} convertMilliseconds={(ms) =>this.convertMilliseconds(ms)}/>:  <div className="movement-data">No Movement Data Available</div>}
                        </div>
                    </div>
                ) :null}
                {trip.ignstatus ? <div className="expand-btn">
                    <span onClick={() => this.toggleExpand(index,trip)}>
                        {isExpanded ? "Show Less" : "Show More"}
                    </span>
                </div> :null}
            </div>
        );
    }

    componentDidMount() {
        window.$('.rw-container').css('top', '53px');
    }
     componentWillUnmount() {
        this.unmounted = true
        window.$('.rw-container').attr('style', function(i, style)
        {
            return style && style.replace(/top[^;]+;?/g, '');
        });
        }

    render() {
        return (
            <div className="tripwise-container">
                <div className="header">
                    <div className="vehicleSelection">
                        <InMultiSelect
                            ref={ref => { this.vehicleSelect = ref; }}
                            data={{  storeData: (state) => {
                                return {
                                    data: (() => {
                                        let newMap = {};
                                        for (let idx in state.vehicleMap) {
                                            if (idx.indexOf("user") === -1) {
                                                newMap[idx] = state.vehicleMap[idx];
                                            }
                                        }
                                        return newMap;
                                    })(),
                                    name: "vehicleno",
                                    id: "vehicleid",
                            
                                };
                            },
                            key:'vehicle',
                            singleSelect: true,
                            onItemChange: this.changeVehicle.bind(this),
                            schemaKey: "cnd_status_report",
                            defaultValue: () => {
                                return {
                                    data:  window.selectedVehicles.map((i) => {
                                        return i.id;
                                    }),
                                    updatedAt:window.selectedVehiclesUpdatedAt,
                                };
                        }}} />
                    </div>
                    <div className="date-section">
                        <div className="ds-picker">
                        <DatePicker
                            wrapperClassName="datepicker"
                            selected={this.state.startDate}
                            onChange={(e) => this.handleStartDate(e)}
                            dateFormat="dd-MM-yyyy"
                        />
                        </div>
                        <div className="ds-picker">
                        <DatePicker
                            wrapperClassName="datepicker"
                            selected={this.state.endDate}
                            onChange={(e) => this.handleEndDate(e)}
                            dateFormat="dd-MM-yyyy"
                        />
                        </div>
                    </div>
                    <div className="tripWise-btn-cnt" style={{display:"flex",gap:'20px',alignItems:"center"}}>
                     <div className="get-download"  style={{
                            width: '40px',
                            height: '37px',
                            lineHeight: '35px',
                            color: '#fff',
                            fontFamily: 'gotham-b',
                            // border: '2px solid #bf3d27',
                            fontWeight:'600',
                            textAlign: 'center',
                            fontSize: '13px',
                            background: 'red',
                            borderRadius:'5px',
                            cursor:'pointer'
                        }}
                        onClick={this.handleDownload}
                        >
                      <i class="fa fa-download" aria-hidden="true"></i>
                    </div>
                    <div className="get-report">
                        <button onClick={() => {this.getReport()}}>Get Report</button>
                    </div>  
                    </div>
                </div>
                <div className="trip-table">
                        {this.state.busy ? <div className="busy-loader"><div className="loader"></div></div> : this.state.tripTableData.length ? this.state.tripTableData.map((data,index) =>{
                            return this.generateTableRow(data,index)
                        }) :this.state.errorMsg ? <div className="error-msg"><span>{this.state.errorMsg}</span></div> : <div className="no-data"><span>NO DATA</span></div> }
                        
                </div>

            </div>
        )
    }
}
export default TripwiseReport         
